import { createFileRoute } from '@tanstack/react-router';
import { requireSession } from '../../auth/require-session.js';
import { SessionError, SessionPending } from '../../auth/SessionStates.js';
import { TrashPage } from '../../trash/trash-page.js';

/** `/trash` (1.V-2 deliverable 1): guarded like every other authenticated route. */
export const Route = createFileRoute('/trash/')({
  staticData: { crumb: 'Trash' },
  beforeLoad: async ({ location }) => ({ me: await requireSession(location.pathname) }),
  pendingComponent: SessionPending,
  pendingMs: 0,
  pendingMinMs: 0,
  errorComponent: SessionError,
  component: TrashPage,
});
